function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { InfoCircle } from "@bolteu/kalep-react-icons";
import { Tooltip } from "../Tooltip";
import { cx } from "../../helpers/utils/cx";
export const Label = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    text,
    infoText,
    required,
    disabled,
    htmlFor,
    htmlProps
  } = _ref;
  return /*#__PURE__*/React.createElement("label", _extends({
    ref: ref,
    className: cx("bolt-font-body-s-accent", "flex items-center gap-1", disabled ? "text-tertiary" : "text-primary"),
    htmlFor: htmlFor
  }, htmlProps), /*#__PURE__*/React.createElement("span", {
    "data-testid": "kalep-label"
  }, text, required && /*#__PURE__*/React.createElement("span", {
    className: cx("text-danger-primary pl-[2px]")
  }, "*")), infoText && /*#__PURE__*/React.createElement(Tooltip, {
    content: infoText
  }, /*#__PURE__*/React.createElement("div", {
    className: cx("box-border flex items-center"),
    tabIndex: 0
  }, /*#__PURE__*/React.createElement(InfoCircle, {
    size: "xs"
  }))));
});